import { InputRadioButton } from "App/Component/ui";
import React from "react";

const RenderCaseRootAndFuncEdit = ({ formData, setFormData }) => {
  return (
    <div
      style={{
        display: "flex",
        gap: "20px",
        marginLeft: "5px",
        marginTop: "0.5rem",
      }}>
      <InputRadioButton
        label={"Is Root"}
        size={"15"}
        id='is_root_func'
        name='is_root_func'
        value='1'
        disabled={true}
        // checked={formData.is_root ? true : false}
        initialValue={formData.is_root_func}
        onChange={(e) =>
          setFormData({
            ...formData,
            is_root_func: "1",
            is_root: 1,
            is_func: 0,
          })
        }
      />

      <InputRadioButton
        label={"Is Func"}
        size={"15"}
        id='is_root_func2'
        name='is_root_func2'
        value='2'
        disabled={true}
        initialValue={formData.is_root_func}
        // checked={formData.is_function ? true : false}

        onChange={(e) =>
          setFormData({
            ...formData,
            is_root_func: "2",
            is_root: 0,
            is_func: 1,
          })
        }
      />

      <InputRadioButton
        label={"Is Menu"}
        size={"15"}
        id='is_root_func3'
        name='is_root_func3'
        value='3'
        disabled={true}
        initialValue={formData.is_root_func}
        // checked={formData.is_function === false && formData.is_root === false ? true : false}
        onChange={(e) =>
          setFormData({
            ...formData,
            is_root_func: "3",
            is_root: 0,
            is_func: 0,
          })
        }
      />
    </div>
  );
};

export default RenderCaseRootAndFuncEdit;
